import request from '@/utils/request'

// 获取提现列表
export function getWithdrawList(data) {
  return request({
    method: 'post',
    path: 'withdraw/lists',
    data
  })
}


// 获取提现预览
export function getWithdrawPreview(data) {
  return request({
    method: 'post',
    path: 'withdraw/preview',
    data
  })
}

// 申请提现
export function setSubmit(data) {
  return request({
    method: 'post',
    path: 'withdraw/submit',
    data
  })
}